import React from 'react';
import { classNames } from '../../utils/classNames/classNames.esm.js';
import '@popperjs/core';
import { testIdGen } from '../../utils/testIdGen.esm.js';
import '../Icon/ImgIcon.esm.js';
import { LoadingIcon } from '../Icon/SemanticIcons.esm.js';
import { Body } from '../Typography/Body.esm.js';
import { Bold } from '../Typography/Bold.esm.js';
import '@headlessui/react';
import '../../utils/constants.esm.js';

/**
 * A styled container to be used within a Card.
 */
function CardHeader({ addClassName, actions, icon, dataMetrics, dataTestId, isBackgroundFetching = false, title, subTitle, ...passThrough }) {
    if (passThrough.appearance || passThrough.level || passThrough.iconLeft) {
        console.warn("This prop has been deprecated and will be ignored!");
    }
    return (React.createElement("div", { "data-metrics": dataMetrics, "data-testid": dataTestId ||
            `card-header-${typeof title === "string" && testIdGen(title)}`, className: classNames("tw-box-border tw-border-solid tw-border-t-0 tw-border-l-0 tw-border-r-0 tw-border-b tw-flex tw-flex-wrap tw-border-gray-300 dark:tw-border-gray-950 tw-rounded-t tw-px-4 tw-py-2", subTitle ? "tw-h-16" : "tw-h-12", addClassName) },
        React.createElement("div", { className: "tw-w-full tw-flex tw-justify-between tw-items-center" },
            React.createElement("div", { className: "tw-flex tw-items-center" },
                icon && (React.createElement("div", { className: "tw-self-start tw-text-gray-600 dark:tw-text-gray-400 tw-mt-1.5" }, icon)),
                React.createElement("div", { className: `tw-flex tw-flex-col ${icon ? "tw-ml-0.5" : ""}` },
                    React.createElement(Bold, { "data-testid": "card-title", className: "tw-font-lato tw-font-semibold tw-text-base tw-text-gray-900 dark:tw-text-gray-100" }, title))),
            (actions || isBackgroundFetching) && (React.createElement("div", { className: "tw-flex tw-items-center" },
                isBackgroundFetching && React.createElement(LoadingIcon, null),
                actions))),
        subTitle && (React.createElement(Body, { "data-testid": "card-subtitle", size: "xs", addClassName: "tw-w-full tw-text-gray-600 dark:tw-text-gray-300" }, subTitle))));
}

export { CardHeader };
//# sourceMappingURL=CardHeader.esm.js.map
